import { render } from "./CheckManagementCreate.vue?vue&type=template&id=af3b2e56&scoped=true"
import script from "./CheckManagementCreate.vue?vue&type=script&lang=js"
export * from "./CheckManagementCreate.vue?vue&type=script&lang=js"

import "./CheckManagementCreate.vue?vue&type=style&index=0&id=af3b2e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3b2e56"]])

export default __exports__